import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {SpecialistViewInterface} from '@interfaces/specialist.interface';
import {SpecialistDataFlowService} from '../services/specialist-data-flow.service';
import {PreviewModalService} from '@services/preview-modal.service';
import {UploadedFile} from '@interfaces/file.interface';

@Component({
    selector: 'app-specialist-view-common',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'specialist-view-common.component.html'
})

export class SpecialistViewCommonComponent implements OnInit {

    @Input() specialist: SpecialistViewInterface;

    @Input() editButton = false;

    /**
     * Ссылки на документы
     * @type {any[]}
     */
    public documentsLinks: {
        label: string;
        callback?: Function;
    }[] = [];

    /**
     * Сформированная строка полного адреса
     */
    public fullAddress: string;

    constructor(
        private dataService: SpecialistDataFlowService,
        private filesPreviewService: PreviewModalService,
    ) {
    }

    ngOnInit() {
        if (!this.specialist) {
            return;
        }

        /**
         * Сначала добавляем все доступные для просмотра документы к отображению
         */
        if (this.hasMedical()) {
            this.documentsLinks.push({
                label: 'Мед. справка',
                callback: () => {
                    this.showMedical();
                }
            });
        }

        if (this.hasPassport()) {
            this.documentsLinks.push({
                label: 'Паспорт',
                callback: () => {
                    this.showPassport();
                }
            });
        }

        if (this.hasEducation()) {
            this.documentsLinks.push({
                label: 'Диплом',
                callback: () => {
                    this.showEducation();
                }
            });
        }

        /**
         * Затем формируем полный адрес для отображения
         * @type {any[]}
         */
        const addressArray = [];
        if (this.specialist.home_address_index) {
            addressArray.push(this.specialist.home_address_index);
        }

        if (this.specialist.home_address) {
            addressArray.push(this.specialist.home_address);
        }

        this.fullAddress = addressArray.join(', ');
    }

    onEditClick() {
        this.dataService.onEdit$.next();
    }

    showPhoto(file: UploadedFile) {
        this.filesPreviewService.show({
            files: [file],
            title: 'Фотография специалиста'
        });
    }

    showPassport() {
        let contentBefore = '';

        if (this.specialist.passport_number) {
            if (this.specialist.is_foreign) {
                contentBefore += `<p>Номер: ${this.specialist.passport_number}</p>`;
            } else {
                contentBefore += `<p>Серия и номер: ${this.specialist.passport_series} ${this.specialist.passport_number}</p>`;
            }
        }

        if (this.specialist.passport_issue) {
            contentBefore += `<p>Кем выдан: ${this.specialist.passport_issue}</p>`;
        }

        if (this.specialist.passport_date) {
            contentBefore += `<p>Дата выдачи: ${this.specialist.passport_date}</p>`;
        }

        const files = this.specialist.file_passport && this.specialist.file_passport.file_url ? [this.specialist.file_passport] : [];

        this.filesPreviewService.show({
            files: files,
            title: 'Паспорт',
            contentBefore: contentBefore,
        });
    }

    showMedical() {
        let contentBefore = '';

        if (this.specialist.medical_date) {
            contentBefore += `<p>Дата выдачи: ${this.specialist.medical_date}</p>`;
        }

        const files = this.specialist.file_medical && this.specialist.file_medical.file_url ? [this.specialist.file_medical] : [];

        this.filesPreviewService.show({
            files: files,
            title: 'Медицинская справка',
            contentBefore: contentBefore,
        });
    }

    showEducation() {
        let contentBefore = '';

        if (this.specialist.education_level_title) {
            contentBefore += `<p>Уровень образования: ${this.specialist.education_level_title}</p>`;
        }

        if (this.specialist.institute) {
            contentBefore += `<p>Образовательное учреждение: ${this.specialist.institute}</p>`;
        }

        if (this.specialist.education_speciality) {
            contentBefore += `<p>Специальность: ${this.specialist.education_speciality}</p>`;
        }

        this.filesPreviewService.show({
            files: this.specialist.file_education && this.specialist.file_education.file_url ? [this.specialist.file_education] : [],
            title: 'Диплом',
            contentBefore: contentBefore,
        });
    }

    hasEducation() {
        if (!this.specialist) {
            return false;
        }

        return Boolean(
            this.specialist.file_education ||
            this.specialist.institute ||
            this.specialist.education_speciality ||
            this.specialist.education_level_title
        );
    }

    hasMedical() {
        if (!this.specialist) {
            return false;
        }

        return Boolean(this.specialist.medical_date || this.specialist.file_medical.file_url);
    }

    hasPassport() {
        if (!this.specialist) {
            return false;
        }

        return Boolean(this.specialist.passport_date ||
            this.specialist.file_passport.file_url ||
            this.specialist.passport_issue ||
            this.specialist.passport_number ||
            this.specialist.passport_series);
    }
}
